<template>
  <div
    class="modal fade"
    id="modal"
    ref="modal"
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content border-0 shadow">
        <div class="modal-header py-2 border-bottom" style="background: linear-gradient(135deg, #E96C15 0%, #d46010 100%);">
          <div class="d-flex align-items-center gap-2 text-white">
            <i class="fa-solid fa-flask-vial" />
            <span class="fw-semibold">{{ $t("Recipe for option") }}</span>
          </div>
          <button type="button" class="btn-close btn-close-white shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="loading">
          <placeholder-content :is-load="true" />
        </div>
        <div class="modal-body p-0" v-else>
          <div class="overflow-x-auto">
            <table class="table table-sm table-hover align-middle mb-0">
              <thead>
                <tr style="background: linear-gradient(135deg, #fff7f2 0%, #ffeee0 100%); border-bottom: 2px solid #eeb084;">
                  <th style="min-width: 180px; color: #7a3a00; font-size: 12px; font-weight: 600;">
                    {{ $t('Inventory Item') }}
                  </th>
                  <th class="text-center" style="min-width: 130px; color: #7a3a00; font-size: 12px; font-weight: 600;">
                    {{ $t('System Quantity') }}
                    <popper
                      :placement="'top'"
                      :hover="true"
                      :arrow="true"
                      :disableClickAway="true"
                      class="popper-2 border-0 m-0"
                    >
                      <i class="fa-solid fa-circle-info" style="opacity: 0.6;" />
                      <template #content>
                        <div>{{ $t('Affects inventory and cost.') }}</div>
                      </template>
                    </popper>
                  </th>
                  <th class="text-center" style="min-width: 130px; color: #7a3a00; font-size: 12px; font-weight: 600;">
                    {{ $t('Display Quantity') }}
                    <popper
                      :placement="'top'"
                      :hover="true"
                      :arrow="true"
                      :disableClickAway="true"
                      class="popper-2 border-0 m-0"
                    >
                      <i class="fa-solid fa-circle-info" style="opacity: 0.6;" />
                      <template #content>
                        <div>{{ $t('What customers or staff see on the POS screen.') }}</div>
                      </template>
                    </popper>
                  </th>
                  <th style="min-width: 80px; color: #7a3a00; font-size: 12px; font-weight: 600;">
                    {{ $t('Unit') }}
                  </th>
                  <th class="text-end" style="min-width: 80px; color: #7a3a00; font-size: 12px; font-weight: 600;">
                    {{ $t('Action') }}
                  </th>
                </tr>
              </thead>
              <tbody style="font-size: 13px;">
                <tr v-for="(recipe, index) in recipes" :key="index">
                  <ItemRecipeForm
                    :index="index"
                    :recipe="recipe"
                    :show-solo="isSplitGroup"
                  />
                </tr>
                <tr v-if="recipes.length == 0">
                  <td colspan="5" class="text-center py-4 text-secondary">
                    <i class="fa-regular fa-folder-open fa-2x mb-2" /><br>
                    <span class="small">{{ $t('No Available Data') }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="px-3 py-2 border-top" style="background: #fafafa;">
            <div class="row align-items-center">
              <div class="col-md-5">
                <div class="d-flex align-items-center gap-2">
                  <i class="fa-solid fa-plus text-secondary" style="font-size: 12px;" />
                  <select2
                    v-model="selectInventory"
                    @select="onSelectedInventory"
                    :options="select2Items.options"
                    :settings="select2Items.setting"
                    :placeholder="$t('Add Input Line') + '...'"
                    class="flex-fill"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- ตั้งค่าเฉพาะกลุ่ม split_portion: ปริมาณคงที่ ไม่หารเฉลี่ย/ไม่นับเป็นตัวหาร -->
          <div v-if="isSplitGroup" class="px-3 py-2 border-top" style="background: #fff7f2;">
            <div class="form-check mb-1">
              <input
                class="form-check-input shadow-none"
                type="checkbox"
                id="splitExempt"
                v-model="splitExempt"
              >
              <label class="form-check-label fw-medium" for="splitExempt" style="font-size: 13px;">
                {{ $t('Fixed portion (not divided among selections)') }}
              </label>
              <div class="text-secondary" style="font-size: 12px;">
                {{ $t('Always uses its full recipe and is not counted when splitting the portion.') }}
              </div>
            </div>
            <div class="text-secondary" style="font-size: 12px;">
              <i class="fa-solid fa-circle-info me-1" style="opacity: 0.6;" />
              <b>{{ $t('Solo') }}</b> — {{ $t('Used when this option is the only selected option with a recipe in its group. Leave blank to use the normal quantity.') }}
            </div>
          </div>
        </div>
        <div class="modal-footer py-2 bg-light" v-if="!loading">
          <button
            type="button"
            class="btn btn-sm btn-light border"
            data-bs-dismiss="modal"
          >
            {{ $t('Close') }}
          </button>
          <ladda
            :disabled="v$.$invalid"
            text="Confirm"
            :btn-class="'btn btn-sm btn-primary'"
            @click="handleConfirm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-recipe";
import { AUTH, API_URLS } from '@/services/endpoint/_constants';
import signature  from '@/services/signature';
import moment from "moment";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';
import Popper from "vue3-popper";
import ItemRecipeForm from './ItemRecipeForm.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.recipes)
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    recipes: {
      type: Array,
      default: []
    },
    optionIndex: {
      type: Number
    }
  },
  data() {
    let vm = this;
    return {
      loading: true,
      selectInventory: [],
      // ค่าจาก option ต้นทาง — commit กลับพร้อม recipes ตอนกดยืนยัน
      splitExempt: false,
      select2Items: {
        options: [],
        setting: {
          dropdownParent: '#modal',
          minimumResultsForSearch: Infinity,
          multiple: true,
          language: {
            maximumSelected: function (e) {
              return vm.$t('You can only select') + ' ' + e.maximum + ' ' + vm.$t('items');
            },
            loadingMore: function (e) {
              return '<i class="fa-solid fa-spinner fa-spin" />'
            }
          },
          ajax: {
            beforeSend: function (request) {
              request.setRequestHeader('Authorization', 'Bearer ' + AUTH.TOKEN);
            },
            url: AUTH.URL + API_URLS.API_MODIFIER_ITEM_RECECIPE,
            data: function (params) {
              var query = {
                search: params.term,
                page: params.page || 1,
                limit: 10
              };
              return signature($.param(query)).substring(1);
            },
            processResults: function (data, params) {
              let option = data.data;
              let pageCurrent = data.meta.current_page;
              option = option.map(function(item) {
                let disabled = false;
                disabled = vm.recipes.find((inventory) => inventory.inventory_id == item.id)? true: false;
                return {
                  id: item.id,
                  text: item.name,
                  unit_id: item.unit_id,
                  unit_name: item.unit_name,
                  disabled: disabled
                }
              });
              return {
                results: option,
                pagination: {
                  more: (pageCurrent * 10) < data.meta.total
                }
              }
            }
          }
        }
      }
    }
  },
  components: {
    Ladda,
    PlaceholderContent,
    Select2,
    Popper,
    ItemRecipeForm
  },
  methods: {
    async onSelectedInventory(e) {
      let vm = this;
      this.selectInventory = [];
      if (!e || !e.id) return;
      if (this.recipes.find((item) => item.inventory_id == e.id)) return;
      this.recipes.push({
        inventory_id: e.id,
        name: e.text,
        unit_id: e.unit_id,
        unit_name: e.unit_name,
        quantity_system: '',
        quantity_system_solo: '',
        quantity_display: '',
        quantity_display_solo: '',
      });
      this.select2Items.options = [];
    },
    async deleteItem(index) {
      this.recipes.splice(index, 1);
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD');
    },
    async fetchData() {
    },
    async handleConfirm() {
      this.$parent.form.options[this.optionIndex].recipes = this.recipes;
      this.$parent.form.options[this.optionIndex].split_exempt = this.splitExempt;
      $(this.$refs.modal).modal('hide');
      // this.v$.$touch();
      // if(this.v$.$invalid) {
      //   return;
      // }
    },
  },
  async mounted() {
    this.splitExempt = !!this.$parent.form.options[this.optionIndex]?.split_exempt;
    $(this.$refs.modal).modal('show');

    $(this.$refs.modal).on('shown.bs.modal',async () => {
      this.loading = true;
      try {
        // await this.fetchData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.$parent.modalRecipeForm.open = false;
    });
  },
  computed: {
    isSplitGroup() {
      return !!this.$parent.form.allow_multiple && this.$parent.form.recipe_behavior === 'split_portion';
    }
  }
}
</script>
